const sideBarBroadcastingCenterRouter = [
  {
    path: '/broadcasting',
    name: 'broadcasting',
    component: () => import('@/views/slideBar/broadcastingCenter'),
    meta: {
      title: '播报中心'
    },
    children: [
      // =====================yuehui=========================
      {
        path: 'construction',
        name: 'broadcasting-construction',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/construction'),
        meta: {
          title: '工地施工'
        }
      },
      {
        path: 'construction/info',
        name: 'broadcasting-construction-info',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/construction/info.vue'),
        meta: {
          title: '工地施工'
        }
      },
      // =====================shiqiong=========================
      {
        path: 'siteInspection-list',
        name: 'siteInspection-list',
        component: () => import('@/views/slideBar/broadcastingCenter/staff/siteInspection'),
        meta: {
          title: '工地巡检'
        }
      },
      {
        path: 'siteInspection-details',
        name: 'siteInspection-details',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/siteInspection/details.vue'),
        meta: {
          title: '工地巡检详情'
        }
      },
      {
        path: 'siteInspection-card',
        name: 'siteInspection-card',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/siteInspection/card.vue'),
        meta: {
          title: '质保卡'
        }
      },
      {
        path: 'siteInspection-noCard',
        name: 'siteInspection-noCard',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/siteInspection/noCard.vue'),
        meta: {
          title: '质保卡'
        }
      },
      {
        path: 'siteInspection-qualityCard',
        name: 'siteInspection-qualityCard',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/siteInspection/quality-card.vue'),
        meta: {
          title: '质保卡'
        }
      },
      {
        path: 'siteInspection-safetyCard',
        name: 'siteInspection-safetyCard',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/siteInspection/safety-card.vue'),
        meta: {
          title: '质保卡'
        }
      },
      {
        path: 'customerComplaint-customer',
        name: 'customerComplaint-customer',
        component: () => import('@/views/slideBar/broadcastingCenter/staff/customerComplaint-customer.vue'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'userOpen',
        name: 'userOpen',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/customerComplaint/userOpen.vue'),
        meta: {
          title: '用户问题处理'
        }
      },
      {
        path: 'feedbackEntry',
        name: 'feedbackEntry',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/customerComplaint/feedbackEntry.vue'),
        meta: {
          title: '问题处理'
        }
      },
      {
        path: 'customerComplaint',
        name: 'customerComplaint',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/customerComplaint/customerComplaint.vue'),
        meta: {
          title: '问题反馈'
        }
      },
      {
        path: 'comments',
        name: 'comments',
        component: () => import('@/views/slideBar/broadcastingCenter/customer/customerComplaint/comments.vue'),
        meta: {
          title: '节点回访'
        }
      }
    ]
  }
]
export default sideBarBroadcastingCenterRouter
